import { EmailTemplate } from "../../types/EmailTemplate";
import { TemplateDefault } from "./TemplateDefault";
import { TemplateSimple } from "./TemplateSimple";
import { TemplateVideo } from "./TemplateVideo";
import { TemplatePromo } from "./TemplatePromo";
import { TemplateAnnouncement } from "./TemplateAnnouncement";
import { TemplateEvent } from "./TemplateEvent";
import { TemplateNewsletter } from "./TemplateNewsletter";
import { TemplateDailyRates } from "./TemplateDailyRates";

export const templatesList: EmailTemplate[] = [
  TemplateDefault,
  TemplateSimple,
  TemplatePromo,
  TemplateAnnouncement,
  TemplateEvent,
  TemplateVideo,
  TemplateNewsletter,
  TemplateDailyRates,
];
